import { useEffect, useState } from 'react';
import { getFingerprint } from '@thumbmarkjs/thumbmarkjs';

// Module-level cache: the fingerprint is stable for a given browser, so we
// compute it once per page load and share across components.
let cached: string | null = null;
let inflight: Promise<string> | null = null;

async function load(): Promise<string> {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = getFingerprint()
    .then((fp) => {
      cached = fp;
      return fp;
    })
    .catch((err) => {
      // Don't let a fingerprint failure block submits. The server will fall
      // back to the numeric user id at the gateway.
      console.warn('fingerprint computation failed:', err);
      cached = '';
      return '';
    });
  return inflight;
}

// Returns the current fingerprint, or null while it's still computing.
// The first submit after page load might fly with null and that's fine —
// the server treats absent fingerprint as "use numeric user id".
export function useFingerprint(): string | null {
  const [fp, setFp] = useState<string | null>(cached);
  useEffect(() => {
    if (cached !== null) return;
    let cancelled = false;
    void load().then((value) => {
      if (!cancelled) setFp(value);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return fp;
}

// For non-React callsites or when you'd rather await it.
export function getFingerprintNow(): Promise<string> {
  return load();
}
